import { render } from "./ReportGroupBuilder.vue?vue&type=template&id=5653d59b&scoped=true"
import script from "./ReportGroupBuilder.vue?vue&type=script&lang=js"
export * from "./ReportGroupBuilder.vue?vue&type=script&lang=js"

import "./ReportGroupBuilder.vue?vue&type=style&index=0&id=5653d59b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5653d59b"],['__file',"resources/js/components/admin/ReportGroupBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5653d59b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5653d59b', __exports__)) {
    api.reload('5653d59b', __exports__)
  }
  
  module.hot.accept("./ReportGroupBuilder.vue?vue&type=template&id=5653d59b&scoped=true", () => {
    api.rerender('5653d59b', render)
  })

}


export default __exports__